import axios from 'axios';
import moment from 'moment'


import {SV_PB_ORCMOCK_ADDRESS, SV_SOJ_ORCMOCK_ADDRESS,LOAD_FORM_PC_BUS_SH } from '../../constants';
import {typesSJPBReview} from '../svtypes/sjpbreviewTypes'
const _ = require('lodash')


const headers = {'Content-Type': 'application/json'}


const  MISSING_TAXES = {
    "taxes": [
        {
            "included": false,
            "amount": "0",
            "currency": "USD",
            "clientAmount": "0",
            "clientCurrency": "EUR"
        }
    ],
    "allIncluded": false
}


function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


  export function pbsaveTravellerSJReviewSuccess (dataOb) {
    console.log('aug2**** testato to save and populate Id ')
    console.log(dataOb)
    return dispatch => {
        //Step 1
        dispatch(svpriceAndTexBegin())
        let {my_data_traveller:{tstfname, tstlname,tstmanme, tstprimaryddress,tstemail}} = dataOb 
        let svurl  = `${SV_PB_ORCMOCK_ADDRESS}/wills/createKey`
        let testatorOb = {
            "fname":tstfname ? tstfname : "john",
    "lname":tstlname ? tstlname :  "mayes",
    "manme":tstmanme ? tstmanme :  "ma",
    "primaryddress":tstprimaryddress ? tstprimaryddress : 'missing address' ,
    "willsnippet":"no property goes to carla",
    "email":tstemail ? tstemail : "alex@yahoo.com",
    "will_date":null
        }
       

        const svhdr = headers 
        axios.post(svurl, testatorOb, {headers:svhdr})
        .then(
            r => {

                console.log('testator create d with id')
                if(r.data){
                    let nuTestator = r.data
                    console.log('testator create d with id', nuTestator)
                    dataOb.my_data_traveller.tstid = r.data.id
                }
                //we need tp dave id 
                dispatch({
                    type: 'SAVETRAVELLER_SJPBREVIEW_SUCCESS',
                    payload: dataOb
                })

        })
        .catch(e => {
            console.log('Testsator create error ***')
            console.log(e)
            dispatch(getPriceAndTexError(e))
        })

        //end ajax
        
    }
   
}

  export function sjpriceAndTexNow(rqValues,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For sjpriceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/spacePriceAndTaxReviewMultiEntity`
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReviewMultiEntityMYRESERVATIONSV`
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const svurl = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :url
          const svhdr = hdr ? hdr: headers 
        
        axios.post(svurl, rqValues, {headers:svhdr})
        .then(
            r => {
                let comData = {
                    "my_data_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_price_confirmation = r.data
                    

                   
                    dispatch(getSJPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_price_confirmation.status = "FAILED"
                    comData.my_data_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getSJPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

/*svmay26 nodify*/
export function sjpriceAndTexNowSecure(rqValues, svtv){
    //pass this to services
    let hbrooms = [
        {
            "rateKey": "20250615|20250616|W|1|311|SGL.ST|FIT RO DEPOSITO|RO||1~1~0||P@07~~25c3f~1454600419~N~~~NOR~~3E63FEAE94684DF174743279490405AAUK0003000100010725c3f",
            "paxes": [
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "James",
                    "surname": "Waytt"
                },
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "Kate",
                    "surname": "Waytt"
                }
            ]
        }
    ]
    /*
    /hotel-api/1.0/bookings
{
    "holder": {
        "name": "HolderFirstName",
        "surname": "HolderLastName"
    },
    "rooms": [
        {
            "rateKey": "20190615|20190616|W|1|1533|DBL.ST|CG BAR RO|RO||1~2~0||N@03DE28CA7DB742F1542362926996AAES0000008000000000725fb2",
            "paxes": [
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "First Adult Name",
                    "surname": "Surname"
                },
                {
                    "roomId": 1,
                    "type": "AD",
                    "name": "Second Adult Name",
                    "surname": "Surname"
                }
            ]
        }
    ],
    "clientReference": "IntegrationAgency",
    "remark": "Booking remarks are to be written here.",
    "tolerance": 2,
    "paymentData": {
        "paymentCard": {
            "cardHolderName": "CardHolderName",
            "cardType": "VI",
            "cardNumber": "4444333322221111",
            "expiryDate": "0320",
            "cardCVC": "123"
        },
        "contactData": {
            "email": "integration@hotelbeds.com",
            "phoneNumber": "654654654"
        }
    }
}

    */
    console.log('%%%%%%%%%%%%%%%sv++++REST API For sjpriceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/spacePriceAndTaxReviewMultiEntity`
        /*sva */
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
       /*
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
        rqValues = {"id":90}
        */
        /*svae*/
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
       
        
        axios.post(url, rqValues, {headers:svheaders})
        .then(
            r => {
                let comData = {
                    "my_data_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob
                /*svmay27 start*/

               
                if(r.data && r.data.associatedRecords  && _.isArray(r.data.associatedRecords )){
                                 
                   
                    let [ob] = r.data.associatedRecords 
                    let {reference,status,creationDate,checkIn,checkOut,spaceKey,name} = ob
                   
                    
                    if(!reference ){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                       
                        comData.my_data_price_confirmation.confirmationNumber =reference
                        comData.my_data_price_confirmation.status = status
                        comData.my_data_price_confirmation.creationDate = creationDate
                        comData.my_data_price_confirmation.checkOut = checkOut
                        comData.my_data_price_confirmation.checkIn = checkIn
                        comData.my_data_price_confirmation.name = name

                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_price_confirmation.confirmationNumber  + "Status:"+ comData.my_data_price_confirmation.status  
                    

                   
                        dispatch(getSJPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                 /*svmay27 end*/
                /*svae */
                if(r.data){
                   
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_price_confirmation = r.data
                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_price_confirmation.confirmationNumber
                    

                   
                        dispatch(getSJPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_price_confirmation.status = "FAILED"
                    comData.my_data_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            }
        ).catch(
            
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}
export function priceAndTexNowSingle(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReview`
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_price_confirmation = r.data
                    

                   
                    dispatch(getSJPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_price_confirmation.status = "FAILED"
                    comData.my_data_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getSJPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

export const svpriceAndTexBegin = () => dispatch => {
    dispatch({
        type:typesSJPBReview.GET_SJPBPRICEANDTAX_BEGIN
        
    })
}
export const sjLoadReviewBegin = () => dispatch => {
    dispatch({
        type:'GET_SJPBREVIEW_BEGIN'
        
    })
}


export const getSJPriceAndTexSuccess = (data) => dispatch => {
    dispatch({
        type: typesSJPBReview.GET_SJPBPRICEANDTAX_SUCCESS,
        payload: data
    })
}
/*
export const pbsaveTravellerSJReviewSuccess = (dataOb) => dispatch => {
    console.log('aug2**** testato to save and populate Id ')
    console.log(dataOb)
    dispatch({
        type: 'SAVETRAVELLER_SJPBREVIEW_SUCCESS',
        payload: dataOb
    })
}
*/

export const geLoadAddressDataDBCustSuccess = (data) => dispatch => {
    dispatch({
        id:-1,
        type:typesSJPBReview.SJPBCREATE_ADDRESS || 'SJPBRESERVATIONS_PRIMARY_ADDRESS',
        payload: data
    })
}

export const geLoadReviewSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_SJPBREVIEW_SUCCESS',
        payload: data
    })
}

export const geLoadReviewNyReservationCustSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_SJPBREVIEW_MYRESERVATION_SV_SUCCESS',
        payload: data
    })
}




export const getPriceAndTexError = (e) =>dispatch => {
    console.log('pricetax error')
    console.log(e)
    dispatch({
        type:typesSJPBReview.GET_SJPBPRICEANDTAX_ERROR,
        /*sva  error:e*/
        payload:e
        /*svae*/
    })
}

export const getLoadReviewError = (e) =>dispatch => {
    dispatch({
        type:'GET_SJPBREVIEW_ERROR',
        error:e
    })
}

export const svLoadReviewdetReset = (data) => dispatch => {
    data = data || {"orderId": -1,
    "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
}
    dispatch({
        type: "RESET_SJPBPRICEANDTAX_INIT",
        payload: data
    })
}



/*

export const getBookError = (e) =>dispatch => {
    dispatch({
        type:typesBook.GET_BOOK_ERROR,
        error:e
    })
}
*/
export function loadReviewSingleNoPriceNow(rqValuesSpaceId){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow from Microservices DB swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        /*
        const url = 'http://localhost:8080/essearch/spaceLoadReview'
        const body = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
          */
          const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
          const body = {
              "query": {
                  "bool": {
                      "must": [
                          {
                              "match": {
                                  "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                              }
                          }
                      ]
                  }
              }
           }
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                  
                   
                    if(r.data.hits.hits.length>0){
                        const ar = r.data.hits.hits
                        let recs_with_duplicate_ar = []
                        let space_rec = {}
                       
                        var item , ob, sod, upperOb
                        
                        ar.forEach(a_rec => {
                            item = {}
                           
                            upperOb = a_rec['_source']
                            ob =lowercaseKeys(upperOb)
    
                            sod =  _.clone(ob)
    
                            
    
                            recs_with_duplicate_ar.push(sod)
                        });
                        space_rec = recs_with_duplicate_ar[0]
                        my_data_review_tp.booking = space_rec
                        let soj = space_rec
                        let svr_location = {
                            "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                            "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                            "county": soj['county'] ? soj['county'] : "albanyt",
                            "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                            "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                            "country": soj['country_name'] ? soj['country_name'] : "usa",
                           "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                           "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                            
                           "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                           "state":soj['state'] ? soj['state'] : "NY"

                        }

                      let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                      my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                      let amenity_name = [
                        "300 feet elevator",
                        "air conditioning",
                        "private bathroom"
                    ]
                      my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                       
                    }
                    else {
                       console.log('getting error * review Load Action')
                       
                    }

                    const comData = {my_data_review:my_data_review_tp}
                    

                   
                    dispatch(geLoadReviewSuccess(comData))
                }
                else {
                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadReviewSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}
/***ne cal start****/

export function loadSJReviewNow_redis(paramOb){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV paramOb :' + paramOb)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        let rqValuesSpaceId = paramOb.paramQSpaceId
        console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
   

        let ratekey = paramOb.ratekey
        let room =  paramOb.room
        let lcode =parseInt(rqValuesSpaceId) 
        let codeKeysOneAr = []
        codeKeysOneAr.push(lcode)
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shLoadReview`
        const body = {
            "query": {
              "match": {
                "code": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }
          const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
        const bodyPriceGet = {
            paramOb: paramOb,
            "query": {
              "match": {
                "code":(rqValuesSpaceId? rqValuesSpaceId: "10000416@4@F@10@10@20251124@7@Y@SVR")
              }
            }
          }
        const urlSpacePriceReal = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewFinal`
        const bodyPriceGetReal =  {

            "svfields": [
                "sojourn_name",
                "code",
                "address",
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-08-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-08-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
            },
            "useCity": true,
            "dst": "PLAYA DE LAS AMERICAS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": codeKeysOneAr,
              
            "destinationCode": "MCO",
            "esqueryRooms": "r1",
            "reviews": [
                {
                    "type": "HOTELBEDS",
                    "maxRate": 5,
                    "minRate": 1,
                    "minReviewCount": 1
                }
            ]

        }
        
        
        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        //shPriceReviewHW
       
        //const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
        /*
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReview`

        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
         */
        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyPriceGet, {headers:headers})
        ], {
  timeout: 7000
})
        .then(
            axios.spread((r,r2)=>{
                console.log('%%%%%%%%%%%%%%%sv++++REST API RS shPriceReview _doc swith sae key ')
   
                let  my_data_review_tp = {
                    "review": {
                        "rate": 4,
                        "num_reviews" :4,
                        "reviewCount": 26,
                        "type": "HOTELBEDS"
                    },
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    
                    "price": {
                        "total": "$923",
                        "net":"$800",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "clienttax":"$30.04",
                            "maintax": 49.08,
                            "maintaxCurrency":"USD",
                            "citytax": 49.08,
                            "citytaxCurrency":"USD",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                   
                    
                     if(r.data.hits.hits.length>0){
                         const ar = r.data.hits.hits
                         let recs_with_duplicate_ar = []
                         let space_rec = {}
                        
                         var item , ob, sod, upperOb
                         
                         ar.forEach(e_rec => {
                             item = {}
                            
                             ob = e_rec['_source']
                            // ob =lowercaseKeys(upperOb)
                            
     
                             sod =  _.clone(ob)
                             let myh = sod
                             let a_rec = sod
                             /*
                             a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                            a_rec['web'] = myh['web'] ?myh['web'] : "NA"
                                */
                           // a_rec['SOJOURN_NAME']= myh['sojourn_name']
                           a_rec["space_key"] = a_rec.code
                           a_rec["sojourn_city"] = a_rec['sojourn_city'] ?a_rec['sojourn_city'] : a_rec['NA']
                            a_rec["country_name"]= myh['countryCode']
                            //let address_s = a_rec["ADDRESS_LINE1"]
                            let address_s = ''
                            const {address} = myh
                            let anum_s = address.number ?address.number : ''
                           
                            if(myh['address']){
                                address_s =  anum_s + " "+address.street
                            }
                            a_rec["address_line1"] = address_s
                            
     
                             recs_with_duplicate_ar.push(sod)
                         });
                         space_rec = recs_with_duplicate_ar[0]
                         if(space_rec['terminals']){
                            my_data_review_tp.terminals = space_rec['terminals']
                         }
                         my_data_review_tp.hotel = space_rec
          

                         my_data_review_tp.booking = space_rec
                         let soj = space_rec
                         let svr_location = {
                             "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                             "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                             "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                             "county": soj['sojourn_city'] ? soj['sojourn_city'] : "albanyt",
                             "postalcode":soj['postalCode'] ? soj['postalCode'] : 12193,
                             "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                             "country": soj['country_name'] ? soj['country_name'] : "usa",
                            "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                            "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                             
                            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                            "state":soj['stateCode'] ? soj['stateCode'] : "NY"
 
                         }
 
                       let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                       my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                       let amenity_name = [
                         "300 feet elevator",
                         "air conditioning",
                         "private bathroom"
                     ]
                       my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name
 
                        
                     }
                     else {
                        console.log('getting error * review Load Action')
                        
                     }
 
                     const comData = {my_data_review:my_data_review_tp}
                     
                     if( r2.data.hotels && r2.data.hotels.hotels  && r2.data.hotels.hotels.length>0){
                        let hcon = r2.data.hotels
                        let ob2,sod2, upperOb2
                        const ar2 = r2.data.hotels.hotels
                        const a_rec2 = ar2[0] || {}
                        //upperOb2 = a_rec2
                        //ob2 =lowercaseKeys(upperOb2)
                        ob2 = a_rec2
                        let myh = a_rec2
                        let a_price = a_rec2
                        const {reviews} = a_price
                        if(reviews && reviews.length > 0){
                           // let reviews_ob = a_price["reviews"]
                           let review_ob = reviews[0]
                       //num_reviews
                           let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                           
                           let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                            review_ob['num_reviews'] = reviewCount
                            let sv_rating = 'Excellent'
                            if(rating == 0){
                             sv_rating = 'Excellent'
         
                            }else if(rating == 1){
         
                             sv_rating = 'Poor'
                         }else if(rating == 2){
                             sv_rating = 'Fair'
                         }else if(rating == 3){
         
                             sv_rating = 'Recommend'
                         }else if(rating == 4){
                             sv_rating = 'Favorite'
                         }else if(rating == 5){
                             sv_rating = 'Excellent'
                         }else {
         
                             sv_rating = 'Excellent'
                            }
                            review_ob['sv_rating'] = sv_rating
                            review_ob['avg_stars_rating'] = rating

                            my_data_review_tp["review"] = review_ob


                        }
                        
                       
                        const {rooms} = ob2
                        let hotel = myh
                        const aroom = rooms[0]
                        const {rates} = aroom
                        const arate = rates[0]
                        let {taxes} = arate
                        let outer_ob_taxes = taxes
                        const {allIncluded} = outer_ob_taxes
                        let atax = outer_ob_taxes.taxes[0]

                        //Books start
                        const {checkIn, checkOut} = hcon
                        let mo_ss = moment(checkIn, 'YYYY-MM-DD');
                        let mo_es = moment(checkOut, 'YYYY-MM-DD');
                        let checkin_s = mo_ss.format('ddd, MMM D, YYYY')
                        let checkout_s = mo_es.format('ddd, MMM D, YYYY')
                        let stay =mo_es.diff(mo_ss, 'days')
                        let roomCode =  aroom.code
                        let request_ob = {
                            "checkin": "OK",
                            "roomCode": roomCode,
                            "stay": stay ? stay: "6",
                            "stayInit": "nights",
                            "checkout": "UU12345",
                            "checkinTime":checkin_s ? checkin_s : "Sat, Sept 9, 3027",
                            "checkinTimePrefix": "From 3:00 PM",
                            "checkoutTimePrefix": "Until 11:00 AM",
                            "checkoutTime": checkout_s? checkout_s: "Sat, Sept 16, 3027"
                        }
                        my_data_review_tp.Request = request_ob
                        //Book End

                        sod2 =  _.clone(arate)
                        sod2["CURRENCY_CODE"] = myh['currency'] ?  myh['currency']  :'NA'

                        /*svsept6 start*/
                        /*
                        let cost = sod2.productcostamount || 100
                        let totaltax = 0
                       
                        let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                        */
                        /*svsept6 end*/
                        sod2['PRODUCT_COST_AMOUNT'] =  arate['net']

                        let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                        console.log('++++++sept6****** START')
                        console.log(cost)
                        
                        let taxPercent = sod2['TAX_PERCENT'] ||  6
                        let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5
                        let totaltax = 0
                        
                        let currencycode='$', maintax =0, citytax=0
                       /*
                        maintax = cost * taxPercent /100
                        maintax = Number(maintax.toFixed(2))
                        
                        citytax = cost * citytaxPercent /100
                        citytax = citytax.toFixed(2)
                        citytax =Number(citytax)
                        totaltax = maintax + citytax
                        totaltax = totaltax.toFixed(2)
                        totaltax = Number(totaltax)
                        console.log('++++++sept6******')
                        
                        */
                        
                        /*sv sept6  start*/
                        if(sod2["CURRENCY_CODE"]== 'DL'){
                            currencycode = '$'
                        }else{
                            currencycode =  '$'
                        }
                        if(sod2["CURRENCY_CODE"]== 'USD'){
                            currencycode = '$'
                        }else{
                            currencycode =  '$'
                        }
                         /*sv sept6  end*/
                         
                        let priceOb= {

                            "total": "$0",
                            "net": currencycode + arate['net'],
                            "depositValue":"100",
                            "depositName":"Damage Deposit (Fully refundable)",
                            "currency": currencycode,
                            "tax": {
                               
                                "taxTotal": atax['currency']+atax['amount'],
                                "clienttax": atax['clientCurrency']+atax['clientAmount'],
                                "maintax":  atax['amount'],
                                "maintaxCurrency":   atax['currency'],
                                "citytax": atax['amount'],
                                "citytaxCurrency": atax['currency'],
                    
                                "taxPercent": "6",
                                "citytaxPercent": "6.5"
                            }
                        }
                        priceOb.rateKey = arate.rateKey
                        let fullPriceWithtax = Number(atax.amount)  + Number(arate.net) 
                        priceOb.total = fullPriceWithtax
                        priceOb.totalWithCurrency = currencycode+fullPriceWithtax
                        console.log(priceOb)
                        console.log('++++++sept6******  END')
                        my_data_review_tp.price = priceOb
                        
                        
                       
                    }
                    
                     dispatch(geLoadReviewSuccess(comData))
                 }
                 else {
                     const comData = {my_data_review:my_data_review_tp}
                     dispatch(geLoadReviewSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}



export const loadCardDataSH=(data)=>{
    console.log('action loadCardData')
    console.log(data)
    let sj_data_card = data

    if(sj_data_card.cardId && sj_data_card.cardId > 0){
        sj_data_card.id =  sj_data_card.cardId
    }else{
        sj_data_card.id = -12
    }

    if(sj_data_card.cardNumber && sj_data_card.cardNumber.length > 0){
        sj_data_card.card =  sj_data_card.cardNumber
    }else{
        sj_data_card.cardNumber = "7777777777777777"
    }
    if(sj_data_card.cardCvv && sj_data_card.cardCvv.length > 0){
        sj_data_card.cvv =  sj_data_card.cardCvv
    }else{
        sj_data_card.cvv = "777"
    }

    if(sj_data_card.cardExpMonth && sj_data_card.cardExpMonth.length > 0){
        sj_data_card.mmexp =  sj_data_card.cardExpMonth
    }else{
        sj_data_card.mmexp = "07"
    }

    if(sj_data_card.cardExpYear && sj_data_card.cardExpYear.length > 0){
        sj_data_card.yyyyexp =  sj_data_card.cardExpYear
    }else{
        sj_data_card.yyyyexp = "77"
    }


    let comData = {sj_data_card : sj_data_card}
    var action = {
       id:-1,
        type: 'SOJMYRESERVATIONS_PRIMARY_CARD',
        payload:comData
    }
    console.log(action)
    return action

}

/*loadReviewNowSJReservationForCustId  **/
/*may26 start*/
export const loadConfirmDataSH=(data)=>{
    console.log('action CREATE_STEP')
    console.log('Oct5 Payment detail calling with data', data)
    console.log(data)
    let my_data_price_confirmation = data
    /*
    if(my_data_address.zipcode && my_data_address.zipcode.length > 0){
        my_data_address.zip =  my_data_address.zipcode
    }else{
        my_data_address.zip = "77777"
    }

    if(my_data_address.addressId && my_data_address.addressId > 0){
        my_data_address.id =  my_data_address.addressId
    }else{
        my_data_address.id = -12
    }
    
*/
    let comData = {my_data_price_confirmation : my_data_price_confirmation}
    console.log('Oct5 Payment detail updating CONFIRMATION FROM BOOKING  for form with data', comData)
   
    var action = {
       id:-1,
        type:typesSJPBReview.SJPBRESERVATIONS_PRIMARY_ADDRESS || 'SJPBRESERVATIONS_PRIMARY_ADDRESS',
        payload:comData
    }
    console.log(action)
    return action

}
/*svmay26 end*/
export const loadAddressDataSH=(data)=>{
    console.log('action CREATE_STEP')
    console.log('Oct5 Payment detail calling with data', data)
    console.log(data)
    let my_data_address = data
    if(my_data_address.zipcode && my_data_address.zipcode.length > 0){
        my_data_address.zip =  my_data_address.zipcode
    }else{
        my_data_address.zip = "77777"
    }

    if(my_data_address.addressId && my_data_address.addressId > 0){
        my_data_address.id =  my_data_address.addressId
    }else{
        my_data_address.id = -12
    }
    

    let comData = {my_data_address : my_data_address}
    console.log('Oct5 Payment detail updating adressdate for form with data', comData)
   
    var action = {
       id:-1,
        type:typesSJPBReview.SJPBCREATE_ADDRESS || 'SJPBRESERVATIONS_PRIMARY_ADDRESS',
        payload:comData
    }
    console.log(action)
    return action

}
/*
export const loadAddressDataDB=(custProfile)=>{
    console.log('action CREATE_STEP')
   
    const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
    let nameQParam = -1
   
   

    
    const body = {
        "id": (custProfile && custProfile.addressId? custProfile.addressId:-1)
       }

       axios.post(url, body, {headers:headers})
       .then(
           r => {
            let comData = {my_data_address : null}
               if( r.data ){
                   const ob = r.data
                 

                   let my_data_address = ob
                    
                    comData.my_data_address = my_data_address
                   
                    console.log(action)
                   
                    dispatch(geLoadAddressDataDBCustSuccess(comData))
                   

               }
               else {
                  
                   dispatch(geLoadAddressDataDBCustSuccess(comData))
               }
           }
       ).catch(
        e=>dispatch(getLoadReviewError(e))
       )

    

}
*/
export function loadReviewNowSJReservationForCustId(rqValuesSpaceId, custProfile){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
        const body = {
            "query": {
              "match": {
                "SPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }

        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`
        const bodyPriceGet = {
            "query": {
              "match": {
                "SPACEKEY.keyword": "10000416@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
//localhost:8086/account/addressListByCustomerIdView
        const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdView`
        const bodyAddressList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
       
        const urlCardList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListByCustomerIdView`
        const bodyCardList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        if(custProfile && (custProfile.customerId > 0)){
            let customerId = custProfile.customerId
            bodyAddressList.docId.push("" + customerId)
            bodyCardList.docId.push("" + customerId)
        }else{
            console.log('custProfile + error by UI')
        }
       
        //localhost:8086/account/cardListByCustomerIdView
        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyPriceGet, {headers:headers}),
            axios.post(urlAddressList, bodyAddressList, {headers:headers}),
            axios.post(urlCardList, bodyCardList, {headers:headers}),
        ], {
  timeout: 7000
})
        .then(
            axios.spread((r,r2, r3,r4)=>{
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                   
                    
                     if(r.data.hits.hits.length>0){
                         const ar = r.data.hits.hits
                         let recs_with_duplicate_ar = []
                         let space_rec = {}
                        
                         var item , ob, sod, upperOb
                         
                         ar.forEach(a_rec => {
                             item = {}
                            
                             upperOb = a_rec['_source']
                             ob =lowercaseKeys(upperOb)
     
                             sod =  _.clone(ob)
     
                             
     
                             recs_with_duplicate_ar.push(sod)
                         });
                         space_rec = recs_with_duplicate_ar[0]
                         my_data_review_tp.booking = space_rec
                         let soj = space_rec
                         let svr_location = {
                             "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                             "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                             "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                             "county": soj['county'] ? soj['county'] : "albanyt",
                             "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                             "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                             "country": soj['country_name'] ? soj['country_name'] : "usa",
                            "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                            "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                             
                            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                            "state":soj['state'] ? soj['state'] : "NY"
 
                         }
 
                       let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                       my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                       let amenity_name = [
                         "300 feet elevator",
                         "air conditioning",
                         "private bathroom"
                     ]
                       my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name
 
                        
                     }
                     else {
                        console.log('getting error * review Load Action')
                        
                     }
 
                     const comData = {my_data_review:my_data_review_tp, my_data_address:null, sj_data_card:null}
                     
                     if( r2.data && r2.data.hits  && r2.data.hits.hits.length>0){
                        let ob2,sod2, upperOb2
                        const ar2 = r2.data.hits.hits
                        const a_rec2 = ar2[0] || {}
                        upperOb2 = a_rec2['_source']
                        //ob2 =lowercaseKeys(upperOb2)
                        ob2 = upperOb2

                        sod2 =  _.clone(ob2)

                        let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                        console.log('++++++sept6****** START')
                        console.log(cost)
                        let taxPercent = sod2['TAX_PERCENT'] ||  6
                        let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5

                        let currencycode='$',  maintax =0, citytax=0
                        let totaltax = 0
                         /*sv sept6  start gt*/
                         if(sod2["CURRENCY_CODE"]== 'DL'){
                            currencycode = '$'
                        
                         }else if(sod2["CURRENCY_CODE"]== 'USD'){
                            currencycode = '$'
                        }else{
                            currencycode =  '$'
                        }
                         /*sv sept6  end*/
                        /*
                        let cost = sod2.productcostamount || 100
                        let totaltax = 0
                       
                        let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                        */
                        maintax = cost * (taxPercent /100)
                        console.log('maintax 1 ',maintax)
                        maintax = Number(maintax.toFixed(2))
                        console.log('maintax 2 ',maintax)
                        
                        citytax = cost * (citytaxPercent /100)
                        citytax = citytax.toFixed(2)
                        console.log('**SEPT-7')
                        console.log(citytax)
                        console.log('citytax 1 ',citytax)
                        citytax =Number(citytax)
                        console.log('citytax 2 ',citytax)
                        totaltax = maintax + citytax
                        console.log('totaltax 1 ',totaltax)
                        totaltax = totaltax.toFixed(2)
                        totaltax = Number(totaltax)

                        let fullPriceWithtax = totaltax + cost

                        if(sod2.currencycode == 'DL'){
                            currencycode = '$'
                        }else{
                            currencycode = sod2.currencycode
                        }
                        let priceOb= {

                            "total": `${fullPriceWithtax}`,
                            "depositValue":"0",
                            "depositName":"Damage Deposit (Fully refundable)",
                            "currency": "$",
                            "tax": {
                               
                                "taxTotal": `${totaltax}`,
                                "maintax":  `${maintax}`,
                                "citytax":  `${citytax}`,
                    
                                "taxPercent": `${taxPercent}`,
                                "citytaxPercent":`${citytaxPercent}`
                            }
                        }

                        console.log(priceOb)
                        console.log('**SEPT-7 end****************' )
                        my_data_review_tp.price = priceOb
                        
                        
                       
                    }
                    let custProfileClone = {
                        customerId: -11
                    }
                    if( r3.data  && r3.data.length>0){

                        

                        let ob3,sod3
                        const ar3 = r3.data 
                        const a_rec3 = ar3[0] || {}
                        ob3 = a_rec3
                        let my_data_address = ob3
                    
                        comData.my_data_address = my_data_address

                        sod3 =  _.clone(ob3)

                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.addressType =sod3.addressType	? sod3.addressType :'B'
                        my_data_review_tp.fname = sod3.fname
                        my_data_review_tp.lname = sod3.lname
                        my_data_review_tp.addressId = sod3.addressId
                        my_data_review_tp.phone = sod3.phone
                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.login = sod3.login
                        my_data_review_tp.city = sod3.city
                        my_data_review_tp.country = sod3.country
                        my_data_review_tp.state = sod3.state
                        my_data_review_tp.address = (sod3.address ?  sod3.address :"No address in DB")
                        my_data_review_tp.zip = sod3.zipcode
                        my_data_review_tp.isdcode = sod3.isdcode
                        my_data_review_tp.dcountry = sod3.country
                        if(sod3.customerId > 0){
                            custProfileClone.customerId = sod3.customerId
                            
                            
                        }
                        if(sod3.addressId > 0){
                            custProfileClone.addressId = sod3.addressId

                        }

                       


                    }


                    
                    comData.custProfile = custProfileClone
                    console.log('%%%sv*** svreviewaction comdata with custProfile froms db start')
                    console.log(custProfile)

                    if( r4.data  && r4.data.length>0){

                        

                        let ob4,sod4
                        const ar4 = r4.data 
                        const a_rec4 = ar4[0] || {}
                        ob4 = a_rec4
                        let sj_data_card = ob4
                        if(sj_data_card.cardId && sj_data_card.cardId > 0){
                            sj_data_card.id =  sj_data_card.cardId
                        }else{
                            sj_data_card.id = -12
                        }
                        if(sj_data_card.cardNumber && sj_data_card.cardNumber.length > 0){
                            sj_data_card.card =  sj_data_card.cardNumber
                        }else{
                            sj_data_card.cardNumber = "7777777777777777"
                        }
                        if(sj_data_card.cardCvv && sj_data_card.cardCvv.length > 0){
                            sj_data_card.cvv =  sj_data_card.cardCvv
                        }else{
                            sj_data_card.cvv = "777"
                        }
                    
                        if(sj_data_card.cardExpMonth && sj_data_card.cardExpMonth.length > 0){
                            sj_data_card.mmexp =  sj_data_card.cardExpMonth
                        }else{
                            sj_data_card.mmexp = "07"
                        }
                    
                        if(sj_data_card.cardExpYear && sj_data_card.cardExpYear.length > 0){
                            sj_data_card.yyyyexp =  sj_data_card.cardExpYear
                        }else{
                            sj_data_card.yyyyexp = "77"
                        }
                    
                    
                        comData.sj_data_card = sj_data_card
                    }
                    console.log(comData)
                    console.log('%%%sv*** svreviewaction comdata with custProfile froms db end')
                     dispatch(geLoadReviewNyReservationCustSuccess(comData))
                 }
                 else {
                     const comData = {my_data_review:my_data_review_tp}
                     comData.custProfile =null
                     dispatch(geLoadReviewNyReservationCustSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}

/*svmay21 start */
/*
export const getSojMailUserSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_FLYREVIEW_MAILUSER_SV_SUCCESS',
        payload: data
    })
}
*/
export function mailIuser(obp){
    console.log('%%%%%%%%%%%%%%%sv++++REST API mailIuser obo :' + obp)
   
    let nameQParam = obp.um
    let custProfile = obp.custProfile
    const {customerId}  = custProfile
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       //http://localhost:8082/amcos/amcosmosbika/kksvverificationCodekk
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svverificationCode`
        const bodyDelete = {
            "email": nameQParam? nameQParam : "suelb22@yahoo.com",
            "subject": "Reservation Details",
            "customerId": customerId ? (""+ customerId):  "-131",
            "status": "OK",
            "digitalCode": "111111"
        }
        

       
        
         
        axios.post(urlDelete, bodyDelete, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_dtoken:  ar }

                   
                    dispatch(getSojMailUserSuccess(comData))
                }
                else {
                    let hwrs =  {
                        "email": "suelb22@yahoo.com",
                        "subject": "Reservation Details",
                        "customerId": "-131",
                        "status": "OK",
                        "digitalCode": "111111"
                    }
                    const comData = { my_data_dtoken: hwrs}
                    dispatch(getLoadReviewError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
        
    }

}
export const getSojMailUserSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_SHREVIEW_MAILUSER_SJ_SUCCESS',
        payload: data
    })
}

export const loadSjcData=(data)=>{
    console.log('action loadSjcData')
    console.log(data)
    let sj_data_dtoken = data

    if(sj_data_dtoken.dtokenId && sj_data_dtoken.dtokenId > 0){
        sj_data_dtoken.id =  sj_data_dtoken.dtokenId
    }else{
        sj_data_dtoken.id = -12
    }

    if(sj_data_dtoken.email && sj_data_dtoken.email.length > 0){
        sj_data_dtoken.email =  sj_data_dtoken.email
    }else{
        sj_data_dtoken.emai = "suelb22@yahoo.com"
    }
    
    let comData = {sj_data_dtoken : sj_data_dtoken}
    var action = {
       id:-1,
        type: 'SOJMYRESERVATIONS_D_TOKEN',
        payload:comData
    }
    console.log(action)
    return action

}



export const loadPcActionSH = (data)=>{
    console.log('action loadPcActionSH  ')
    console.log(data)
    let sjcpcData = {
        id:-1,
        gene:'add_step',
    }

    sjcpcData = data
    let action ={
        id:-1,
        
        sjcpcData:sjcpcData,
        //type:LOAD_CLASSIFIERSTEP_CSTEPFORM_BUS,
        type:LOAD_FORM_PC_BUS_SH,
        templateData:data
    }

    return action
}


/*svmay26 start*/

export function loadSJReviewNow_old_working_jun2(paramOb){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV paramOb :' + paramOb)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        let rqValuesSpaceId = paramOb.paramQSpaceId
        console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
   

        let ratekey = paramOb.ratekey
        let room =  paramOb.room
        let lcode =parseInt(rqValuesSpaceId) 

        let checkIn= 	"2025-06-15"
        let checkOut= 	"2025-06-25"
        let codeKeysOneAr = []
        codeKeysOneAr.push(lcode)
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shLoadReview`
        const body = {
            "query": {
              "match": {
                "code": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }
          const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
        const bodyPriceGet = {
            paramOb: paramOb,
            "query": {
              "match": {
                "code":(rqValuesSpaceId? rqValuesSpaceId: "10000416@4@F@10@10@20251124@7@Y@SVR")
              }
            }
          }
        const urlSpacePriceReal = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewFinal`
        const bodyPriceGetReal =  {

            "svfields": [
                "sojourn_name",
                "code",
                "address",
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-08-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-08-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
            },
            "useCity": true,
            "dst": "PLAYA DE LAS AMERICAS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": codeKeysOneAr,
              
            "destinationCode": "MCO",
            "esqueryRooms": "r1",
            "reviews": [
                {
                    "type": "HOTELBEDS",
                    "maxRate": 5,
                    "minRate": 1,
                    "minReviewCount": 1
                }
            ]

        }
        
        
        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        //shPriceReviewHW
       
        //const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
        /*
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReview`

        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
         */
        axios.post(url, body, {headers:headers},{
            timeout: 7000
          }).then( r=>{
            console.log('%%%%%%%%%%%%%%%sv++++REST API RS shPriceReview _doc swith sae key ')
   
            let  my_data_review_tp = {
                "review": {
                    "rate": 4,
                    "num_reviews" :4,
                    "reviewCount": 26,
                    "type": "HOTELBEDS"
                },
                "Request": {
                    "checkin": "OK",
                    "stay": "6",
                    "stayInit": "nights",
                    "checkout": "UU12345",
                    "checkinTime": "Sat, Sept 9, 3027",
                    "checkinTimePrefix": "From 3:00 PM",
                    "checkoutTimePrefix": "Until 11:00 AM",
                    "checkoutTime": "Sat, Sept 16, 3027"
                },
                "spaceDet": {
                
                    "space_details": "Queen Room with Two Queen Beds",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "cancellation": "Free cancellation before December 9, 2024 ",
                    "guests": "2 adults ",
                    "cleaniness_score" : "7.7",
                    "non_smoking":true,
            
                    "space_amenity_name": [
                        "300 feet elevator",
                        "air conditioning",
                        "private bathroom"
                    ]
                   
                   
                },
                "booking": {
                    "resort_name": "Cambria Hotel Orlando Airport",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "stayDet": "6 nights",
                    "num_reviews": 101,
                    "amenity_name": [
                        "HotTub",
                        "Spa",
                        "Swimming pool",
                        "Laundry"
                    ],
                    "num_reviews_label": "Good, ",
                    "rating_detail":" Excellebt, 9.1",
                    "num_reviews_detail": "Good, 101 reviews"
                   
                },
                
                "price": {
                    "total": "$923",
                    "net":"$800",
                    "depositValue":"$200.26",
                    "depositName":"Damage Deposit (Fully refundable)",
                    "currency": "usd",
                    "tax": {
                       
                        "taxTotal": "$102.34",
                        "clienttax":"$30.04",
                        "maintax": 49.08,
                        "maintaxCurrency":"USD",
                        "citytax": 49.08,
                        "citytaxCurrency":"USD",
            
                        "taxPercent": "6",
                        "citytaxPercent": "6.5"
                    }
                },
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
            if(r.data){

               
                
                 if(r.data.hits.hits.length>0){
                     const ar = r.data.hits.hits
                     let recs_with_duplicate_ar = []
                     let space_rec = {}
                    
                     var item , ob, sod, upperOb
                     
                     ar.forEach(e_rec => {
                         item = {}
                        
                         ob = e_rec['_source']
                        // ob =lowercaseKeys(upperOb)
                        
 
                         sod =  _.clone(ob)
                         let myh = sod
                         let a_rec = sod
                         /*
                         a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"
                            */
                       // a_rec['SOJOURN_NAME']= myh['sojourn_name']
                       a_rec["space_key"] = a_rec.code
                       a_rec["sojourn_city"] = a_rec['sojourn_city'] ?a_rec['sojourn_city'] : a_rec['NA']
                        a_rec["country_name"]= myh['countryCode']
                        //let address_s = a_rec["ADDRESS_LINE1"]
                        let address_s = ''
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["address_line1"] = address_s
                        
 
                         recs_with_duplicate_ar.push(sod)
                     });
                     space_rec = recs_with_duplicate_ar[0]
                     let hotel = space_rec
                     let myh = space_rec
                     if(space_rec['terminals']){
                        my_data_review_tp.terminals = space_rec['terminals']
                     }
                     my_data_review_tp.hotel = space_rec
      

                     my_data_review_tp.booking = space_rec
                     let soj = space_rec
                     let svr_location = {
                         "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                         "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                         "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                         "county": soj['sojourn_city'] ? soj['sojourn_city'] : "albanyt",
                         "postalcode":soj['postalCode'] ? soj['postalCode'] : 12193,
                         "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                         "country": soj['country_name'] ? soj['country_name'] : "usa",
                        "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                        "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                         
                        "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                        "state":soj['stateCode'] ? soj['stateCode'] : "NY"

                     }

                   let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                   my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                   let amenity_name = [
                     "300 feet elevator",
                     "air conditioning",
                     "private bathroom"
                 ]
                   my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                   const comData = {my_data_review:my_data_review_tp}

                   const {reviews, room} = paramOb
                   if(reviews && reviews.length > 0){
                      // let reviews_ob = a_price["reviews"]
                      let review_ob = reviews[0]
                  //num_reviews
                      let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                      
                      let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                       review_ob['num_reviews'] = reviewCount
                       let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       review_ob['sv_rating'] = sv_rating
                       review_ob['avg_stars_rating'] = rating
  
                       my_data_review_tp["review"] = review_ob
  
  
                   }
                   
                   const aroom = room['room']
                 
                   if(aroom){
                      
                     
                      const {rates} = aroom
                      const arate = rates[0]
                      let {taxes} = arate
                      let outer_ob_taxes = taxes
                      const {allIncluded} = outer_ob_taxes
                      let atax = outer_ob_taxes.taxes[0]
  
                      //Books start
                      
                      let mo_ss = moment(checkIn, 'YYYY-MM-DD');
                      let mo_es = moment(checkOut, 'YYYY-MM-DD');
                      let checkin_s = mo_ss.format('ddd, MMM D, YYYY')
                      let checkout_s = mo_es.format('ddd, MMM D, YYYY')
                      let stay =mo_es.diff(mo_ss, 'days')
                      let roomCode =  aroom.code
                      let request_ob = {
                          "checkin": "OK",
                          "roomCode": roomCode,
                          "stay": stay ? stay: "6",
                          "stayInit": "nights",
                          "checkout": "UU12345",
                          "checkinTime":checkin_s ? checkin_s : "Sat, Sept 9, 3027",
                          "checkinTimePrefix": "From 3:00 PM",
                          "checkoutTimePrefix": "Until 11:00 AM",
                          "checkoutTime": checkout_s? checkout_s: "Sat, Sept 16, 3027"
                      }
                      my_data_review_tp.Request = request_ob
                      //Book End
  
                      let sod2 =  _.clone(arate)
                      sod2["CURRENCY_CODE"] = myh['currency'] ?  myh['currency']  :'NA'
  
                      /*svsept6 start*/
                      /*
                      let cost = sod2.productcostamount || 100
                      let totaltax = 0
                     
                      let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                      */
                      /*svsept6 end*/
                      sod2['PRODUCT_COST_AMOUNT'] =  arate['net']
  
                      let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                      console.log('++++++sept6****** START')
                      console.log(cost)
                      
                      let taxPercent = sod2['TAX_PERCENT'] ||  6
                      let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5
                      let totaltax = 0
                      
                      let currencycode='$', maintax =0, citytax=0
                     /*
                      maintax = cost * taxPercent /100
                      maintax = Number(maintax.toFixed(2))
                      
                      citytax = cost * citytaxPercent /100
                      citytax = citytax.toFixed(2)
                      citytax =Number(citytax)
                      totaltax = maintax + citytax
                      totaltax = totaltax.toFixed(2)
                      totaltax = Number(totaltax)
                      console.log('++++++sept6******')
                      
                      */
                      
                      /*sv sept6  start*/
                      if(sod2["CURRENCY_CODE"]== 'DL'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                      if(sod2["CURRENCY_CODE"]== 'USD'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                       /*sv sept6  end*/
                       
                      let priceOb= {
  
                          "total": "$0",
                          "net": currencycode + arate['net'],
                          "depositValue":"100",
                          "depositName":"Damage Deposit (Fully refundable)",
                          "currency": currencycode,
                          "tax": {
                             
                              "taxTotal": atax['currency']+atax['amount'],
                              "clienttax": atax['clientCurrency']+atax['clientAmount'],
                              "maintax":  atax['amount'],
                              "maintaxCurrency":   atax['currency'],
                              "citytax": atax['amount'],
                              "citytaxCurrency": atax['currency'],
                  
                              "taxPercent": "6",
                              "citytaxPercent": "6.5"
                          }
                      }
                      priceOb.rateKey = arate.rateKey
                      let fullPriceWithtax = Number(atax.amount)  + Number(arate.net) 
                      priceOb.total = fullPriceWithtax
                      priceOb.totalWithCurrency = currencycode+fullPriceWithtax
                      console.log(priceOb)
                      console.log('++++++sept6******  END')
                      my_data_review_tp.price = priceOb
                   }
                   dispatch(geLoadReviewSuccess(comData))
                    
                 }
                 else {
                    console.log('getting error * review Load Action')
                    
                 }


                 /*sv end r2*/
                
                
             }
             else {
                 const comData = {my_data_review:my_data_review_tp}
                 dispatch(geLoadReviewSuccess(comData))
             }

          }).catch(
            e=>dispatch(getLoadReviewError(e))
        )

        /*svend ******/
   
    }

}


/*svmay26 end*/

/*svjun4 start*/

export function loadSJReviewNow(paramOb){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV paramOb :' + paramOb)
    return dispatch => {
        dispatch(sjLoadReviewBegin())
        let rqValuesSpaceId = paramOb.paramQSpaceId
        console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
   

        let ratekey = paramOb.ratekey
        let room =  paramOb.room
        let lcode =parseInt(rqValuesSpaceId) 

        let checkIn= 	"2025-06-15"
        let checkOut= 	"2025-06-25"
        let codeKeysOneAr = []
        codeKeysOneAr.push(lcode)
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shLoadReview`
        const body = {
            "query": {
              "match": {
                "code": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }
          const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
          const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
    
        
        
          
        //shPriceReviewHW
       
        //const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
        /*
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReview`

        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/shPriceReviewHW`
         */
       

        /*svend ******/
        /*svmulti start*/
        axios.all([
            axios.post(url, body, {headers:headers}),
           
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ], {
            timeout: 7000
          })
          .then( axios.spread((r,r5)=>{
            //svcheck
            console.log('%%%%%%%%%%%%%%%sv++++REST API RS shPriceReview _doc swith sae key ')
   
            let  my_data_review_tp = {
                "review": {
                    "rate": 4,
                    "num_reviews" :4,
                    "reviewCount": 26,
                    "type": "HOTELBEDS"
                },
                "Request": {
                    "checkin": "OK",
                    "stay": "6",
                    "stayInit": "nights",
                    "checkout": "UU12345",
                    "checkinTime": "Sat, Sept 9, 3027",
                    "checkinTimePrefix": "From 3:00 PM",
                    "checkoutTimePrefix": "Until 11:00 AM",
                    "checkoutTime": "Sat, Sept 16, 3027"
                },
                "spaceDet": {
                
                    "space_details": "Queen Room with Two Queen Beds",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "cancellation": "Free cancellation before December 9, 2024 ",
                    "guests": "2 adults ",
                    "cleaniness_score" : "7.7",
                    "non_smoking":true,
            
                    "space_amenity_name": [
                        "300 feet elevator",
                        "air conditioning",
                        "private bathroom"
                    ]
                   
                   
                },
                "booking": {
                    "resort_name": "Cambria Hotel Orlando Airport",
                    "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                    "stayDet": "6 nights",
                    "num_reviews": 101,
                    "amenity_name": [
                        "HotTub",
                        "Spa",
                        "Swimming pool",
                        "Laundry"
                    ],
                    "num_reviews_label": "Good, ",
                    "rating_detail":" Excellebt, 9.1",
                    "num_reviews_detail": "Good, 101 reviews"
                   
                },
                
                "price": {
                    "total": "$923",
                    "net":"$800",
                    "depositValue":"$200.26",
                    "depositName":"Damage Deposit (Fully refundable)",
                    "currency": "usd",
                    "tax": {
                       
                        "taxTotal": "$102.34",
                        "clienttax":"$30.04",
                        "maintax": 49.08,
                        "maintaxCurrency":"USD",
                        "citytax": 49.08,
                        "citytaxCurrency":"USD",
            
                        "taxPercent": "6",
                        "citytaxPercent": "6.5"
                    }
                },
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
            if(r.data){

               
                
                 if(r.data.hits.hits.length>0){
                     const ar = r.data.hits.hits
                     let recs_with_duplicate_ar = []
                     let space_rec = {}
                    
                     var item , ob, sod, upperOb
                     
                     ar.forEach(e_rec => {
                         item = {}
                        
                         ob = e_rec['_source']
                        // ob =lowercaseKeys(upperOb)
                        
 
                         sod =  _.clone(ob)
                         let myh = sod
                         let a_rec = sod
                         /*
                         a_rec['ranking'] = myh['ranking'] ?myh['ranking'] : "NA"
                        a_rec['web'] = myh['web'] ?myh['web'] : "NA"
                            */
                       // a_rec['SOJOURN_NAME']= myh['sojourn_name']
                       a_rec["space_key"] = a_rec.code
                       a_rec["sojourn_city"] = a_rec['sojourn_city'] ?a_rec['sojourn_city'] : a_rec['NA']
                        a_rec["country_name"]= myh['countryCode']
                        //let address_s = a_rec["ADDRESS_LINE1"]
                        let address_s = ''
                        const {address} = myh
                        let anum_s = address.number ?address.number : ''
                       
                        if(myh['address']){
                            address_s =  anum_s + " "+address.street
                        }
                        a_rec["address_line1"] = address_s
                        
 
                         recs_with_duplicate_ar.push(sod)
                     });
                     space_rec = recs_with_duplicate_ar[0]
                     let hotel = space_rec
                     let myh = space_rec
                     if(space_rec['terminals']){
                        my_data_review_tp.terminals = space_rec['terminals']
                     }
                     my_data_review_tp.hotel = space_rec
      

                     my_data_review_tp.booking = space_rec
                     let soj = space_rec
                     let svr_location = {
                         "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                         "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                         "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                         "county": soj['sojourn_city'] ? soj['sojourn_city'] : "albanyt",
                         "postalcode":soj['postalCode'] ? soj['postalCode'] : 12193,
                         "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                         "country": soj['country_name'] ? soj['country_name'] : "usa",
                        "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                        "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                         
                        "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                        "state":soj['stateCode'] ? soj['stateCode'] : "NY"

                     }

                   let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                   my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                   let amenity_name = [
                     "300 feet elevator",
                     "air conditioning",
                     "private bathroom"
                 ]
                   my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                   const comData = {my_data_review:my_data_review_tp}

                   const {reviews, room} = paramOb
                   if(reviews && reviews.length > 0){
                      // let reviews_ob = a_price["reviews"]
                      let review_ob = reviews[0]
                  //num_reviews
                      let rating = (review_ob['rate']? review_ob['rate'] : 0 )
                      
                      let reviewCount = (review_ob[ "reviewCount"]? review_ob[ "reviewCount"] : 0 )
                       review_ob['num_reviews'] = reviewCount
                       let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       review_ob['sv_rating'] = sv_rating
                       review_ob['avg_stars_rating'] = rating
  
                       my_data_review_tp["review"] = review_ob
  
  
                   }
                   
                   const aroom = room['room']
                 
                   if(aroom){
                      
                     
                      const {rates} = aroom
                      const arate = rates[0]
                      let {taxes} = arate
                      
                      let outer_ob_taxes = taxes ? taxes : MISSING_TAXES
                     
                      const {allIncluded} = outer_ob_taxes
                      let atax = outer_ob_taxes.taxes[0]
  
                      //Books start
                      
                      let mo_ss = moment(checkIn, 'YYYY-MM-DD');
                      let mo_es = moment(checkOut, 'YYYY-MM-DD');
                      let checkin_s = mo_ss.format('ddd, MMM D, YYYY')
                      let checkout_s = mo_es.format('ddd, MMM D, YYYY')
                      let stay =mo_es.diff(mo_ss, 'days')
                      let roomCode =  aroom.code
                      let request_ob = {
                          "checkin": "OK",
                          "roomCode": roomCode,
                          "stay": stay ? stay: "6",
                          "stayInit": "nights",
                          "checkout": "UU12345",
                          "checkinTime":checkin_s ? checkin_s : "Sat, Sept 9, 3027",
                          "checkinTimePrefix": "From 3:00 PM",
                          "checkoutTimePrefix": "Until 11:00 AM",
                          "checkoutTime": checkout_s? checkout_s: "Sat, Sept 16, 3027"
                      }
                      my_data_review_tp.Request = request_ob
                      //Book End
  
                      let sod2 =  _.clone(arate)
                      sod2["CURRENCY_CODE"] = myh['currency'] ?  myh['currency']  :'NA'
  
                      /*svsept6 start*/
                      /*
                      let cost = sod2.productcostamount || 100
                      let totaltax = 0
                     
                      let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                      */
                      /*svsept6 end*/
                      sod2['PRODUCT_COST_AMOUNT'] =  arate['net']
  
                      let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                      console.log('++++++sept6****** START')
                      console.log(cost)
                      
                      let taxPercent = sod2['TAX_PERCENT'] ||  6
                      let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5
                      let totaltax = 0
                      
                      let currencycode='$', maintax =0, citytax=0
                     /*
                      maintax = cost * taxPercent /100
                      maintax = Number(maintax.toFixed(2))
                      
                      citytax = cost * citytaxPercent /100
                      citytax = citytax.toFixed(2)
                      citytax =Number(citytax)
                      totaltax = maintax + citytax
                      totaltax = totaltax.toFixed(2)
                      totaltax = Number(totaltax)
                      console.log('++++++sept6******')
                      
                      */
                      
                      /*sv sept6  start*/
                      if(sod2["CURRENCY_CODE"]== 'DL'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                      if(sod2["CURRENCY_CODE"]== 'USD'){
                          currencycode = '$'
                      }else{
                          currencycode =  '$'
                      }
                       /*sv sept6  end*/
                       
                      let priceOb= {
  
                          "total": "$0",
                          "net": currencycode + arate['net'],
                          "depositValue":"100",
                          "depositName":"Damage Deposit (Fully refundable)",
                          "currency": currencycode,
                          "tax": {
                             
                              "taxTotal": atax['currency']+atax['amount'],
                              "clienttax": atax['clientCurrency']+atax['clientAmount'],
                              "maintax":  atax['amount'],
                              "maintaxCurrency":   atax['currency'],
                              "citytax": atax['amount'],
                              "citytaxCurrency": atax['currency'],
                  
                              "taxPercent": "6",
                              "citytaxPercent": "6.5"
                          }
                      }
                      priceOb.rateKey = arate.rateKey
                      let fullPriceWithtax = Number(atax.amount)  + Number(arate.net) 
                      priceOb.total = fullPriceWithtax
                      priceOb.totalWithCurrency = currencycode+fullPriceWithtax
                      console.log(priceOb)
                      console.log('++++++sept6******  END')
                      my_data_review_tp.price = priceOb
                   }
                   //svr5 start
                   let my_data_geo = null
                   console.log('svjun4 my_data_geo********* is in comdata')
                   console.log(r5.data )
                   if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                    my_data_geo = r5.data
                    comData.my_data_geo = my_data_geo
                   }
                   console.log(comData )
                   //svr5 end
                   dispatch(geLoadReviewSuccess(comData))
                    
                 }
                 else {
                    console.log('getting error * review Load Action')
                    let mye = new Error('service call faile getting error * review Load Action')
                    dispatch(getLoadReviewError(mye))
                    
                 }


                 /*sv end r2*/
                
                
             }
             else {
                 const comData = {my_data_review:my_data_review_tp}
                 comData.my_data_geo =  {
                    "countryTypes": [
                        {
                            "name": "United STates America",
                            "a2": "US",
                            "a3": "USA",
                            "isonum": "840"
                        },
                       
                        {
                            "name": "Canada",
                            "isdcode": "01",
                            "a2": "CA",
                            "a3": "CAN",
                            "isonum": "124"
                        }
                    ],
                    "stateTypes": [
                        {
                            "name": "California",
                            "a2": "CA"
                        },
                        {
                            "name": "New York",
                            "a2": "NY"
                        },
                        {
                            "name": "Texas",
                            "a2": "TX"
                        }
                    ],
                    "isdcodeTypes": [
                        {
                            "name": "United States Of America(+1)",
                            "value": "+1"
                        }
                    ],
                    "genderTypes": [
                        {
                            "name": "CL_MALE",
                            "value": "MALE"
                        },
                        {
                            "name": "CL_FEMALE",
                            "value": "FEMALE"
                        }
                    ]
                }
                 dispatch(geLoadReviewSuccess(comData))
             }
            //svcheckend

          }
          )
          ).catch(
            e=>dispatch(getLoadReviewError(e))
          )
        
        /*svmultiend*/
   
    }

}
/*svjun4 end*/